export default "__VITE_ASSET__ddc2ba4c__"